export default {
  state: {
    message: null,
  },
  getters: {
    getMessage: state => state.message,
  },
  mutations: {
    close(state) {
      state.message = null;
    },
    set(state, message) {
      state.message = message;
    },
  },
  actions: {
    close({ commit }) {
      commit('close');
    },
    set({ commit }, message) {
      commit('set', message);
    },
  },
};
